import { useQuery } from '@tanstack/react-query';
import { getApi } from '../../api/bootstrap';

export const MI_SIMULACION_QUERY_KEY = ['mi-simulacion'] as const;

/**
 * Hook que envuelve `GET /api/mi-simulacion`. La validación Zod ocurre
 * en `@alter/api-client`; el hook devuelve la respuesta tipada o un error.
 *
 * **Se pide una sola vez al entrar** (D-2 de la tanda 2): el endpoint no es
 * de solo lectura — crea la simulación si no existe y marca `ABANDONADA`
 * la que lleve más de 15 min inactiva (nota de interfaz §7). Sin
 * refetch al montar, al reconectar ni al enfocar, y `staleTime` infinito.
 * El único refetch es el botón "Actualizar", explícito.
 *
 * El 401 se maneja globalmente en `QueryCache.onError` (ver
 * `handleApiError.ts`); este hook NO replica esa lógica.
 */
export function useMiSimulacion() {
  return useQuery({
    queryKey: MI_SIMULACION_QUERY_KEY,
    queryFn: () => getApi().simulacionClient.getMiSimulacion(),
    staleTime: Infinity,
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
  });
}
